import connectionsStore, { PlaceID3, ShemeNode3, isRackSectionData3, toWorkEquipment3 } from "@mobx/store/connections";
import { IRack, isIRack, isMinerItem3 } from "@mobx/store/locations/types";
import { EQUIPMENT_TYPE, IWorkEquipment } from "@store/Equipments/actionTypes";

export interface RackItemEquipmentConnections3 {
  [rackItemID: number]: IWorkEquipment;
};

export const useRackItemEquipmentConnections3 = (kind: EQUIPMENT_TYPE, placeID?: PlaceID3): RackItemEquipmentConnections3 | undefined => {
    if (placeID === undefined) return undefined;
    const editor = connectionsStore.getPlaceStore(placeID)?.kinds[kind];
    const nodes = editor?.data.nodes
      .filter(
        n =>
          n.data.type === "consumer" &&
          ((isRackSectionData3(n.data.userData) && n.data.userData.rackItemID !== undefined) ||
            isMinerItem3(n.data.userData))
      )
      .map((n) => {
        const userData = n.data.userData;
        if (isRackSectionData3(userData)) return [n.id, userData.rackItemID!] as [string, number];
        if (isMinerItem3(userData)) return [n.id, userData.id] as [string, number];
        throw new Error("Unexpected rack item consumer data");
      });
    if (nodes === undefined) return undefined;
    const nodesTable = Object.fromEntries(nodes);
    const edges = editor?.data.edges
      .filter(edge => nodesTable[edge.target] !== undefined)
      .map(edge => [nodesTable[edge.target], edge.source] as [number, string]);
    if (edges === undefined) return undefined;
    const edgesTable = Object.fromEntries(edges);
    const eqNodes = Object.keys(edgesTable)
      .map(ns => [ns, editor?.data.nodes.find(n => n.id === edgesTable[ns])] as [string, ShemeNode3])
      .filter(([_, node]) => node !== undefined)
      .map(([ns, node]) => [ns, toWorkEquipment3(node!.data)]);
    return eqNodes ? Object.fromEntries(eqNodes) : undefined;
}

export interface RackEquipmentConnections3 {
  [rackID: string]: IWorkEquipment;
};

export const useRackEquipmentConnections3 = (kind: EQUIPMENT_TYPE, placeID?: PlaceID3): RackEquipmentConnections3 | undefined => {
    if (placeID === undefined) return undefined;
    const editor = connectionsStore.getPlaceStore(placeID)?.kinds[kind];
    const nodes = editor?.data.nodes
      .filter(n => n.data.type === "consumer" && isIRack(n.data.userData))
      .map(n => ([n.id, (n.data.userData as IRack).id] as [string, number]));
    if (nodes === undefined) return undefined;
    const nodesTable = Object.fromEntries(nodes);
    const edges = editor?.data.edges
      .filter(edge => nodesTable[edge.target] !== undefined)
      .map(edge => [nodesTable[edge.target], edge.source] as [number, string]);
    if (edges === undefined) return undefined;
    const edgesTable = Object.fromEntries(edges);
    const eqNodes = Object.keys(edgesTable)
      .map(ns => [ns, editor?.data.nodes.find(n => n.id === edgesTable[ns])] as [string, ShemeNode3])
      .filter(([_, node]) => node !== undefined)
      .map(([ns, node]) => [ns, toWorkEquipment3(node!.data)]);
    return eqNodes ? Object.fromEntries(eqNodes) : undefined;
}
